import gladlyConfig from "./gladly.config";

window[gladlyConfig.functionName] = {
  init({ environment = gladlyConfig.environment, appId = gladlyConfig.options.appId } = {}) {
    // Gladly IIFE
    (!function(c,n,r,t){
      if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}
    }(window,document,'Gladly', environment));

    if (gladlyConfig.autoConfig) {
      window.gladlyConfig = { appId };
    } else {
      Gladly.init({ appId }).then(() => {
        // This is called once Sidekick has been initialized.

        // Gladly show chat will display the chat interface
        if (gladlyConfig.autoDisplayChat) {
          Gladly.show();
        }

        if (!gladlyConfig.startChatButton) {
          return;
        }

        // An element with the id "start-chat" is assumed to be on the page.
        const startChatButton = document.getElementById(gladlyConfig.selector);

        // An onClick handler can be attached to the "start-chat" element
        startChatButton.onclick = function () { Gladly.show(); };

        // This API call gets the current availability
        const availablility = Gladly.getAvailability();

        // Setting the availability as the class name on the "start-chat" element,
        // this allows us to change the look of the button via CSS.
        startChatButton.setAttribute('class', availablility.toLowerCase());

        // Subscribe to changes in availability, and update the class on the "start-chat" element.
        Gladly.on('availability:change', (availablility) => {
          startChatButton.setAttribute('class', availablility.toLowerCase());
        });
      }).catch((error) => {
        // If anything goes wrong when Sidekick is being initialized, this gets called.
        console.log('error:', error);
      });
    };
  },
};
